export default __webpack_public_path__ + "static/media/blLogo.921d6942.ico";